import SettingSection from 'flow/components/Setting/SettingSection';
import Divider from 'flow/components/ui-components/Divider';
import RadioButton from 'flow/components/ui-components/RadioButton';
import useAppContext from 'flow/hooks/useAppContext';
import useExtension from 'flow/hooks/useExtension';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { licenseIsMobile } from 'flow/utils/flow-utils';
import React from 'react';
import { ConnectCallsValues } from '../CreateProfileModal';

interface Props {
    extensionKey: ExtensionKey;
    selected: ConnectCallsValues;
    onChange: (newValue: ConnectCallsValues) => void;
}

const ConnectCallsToSection = ({ extensionKey, selected, onChange }: Props) => {
    const { i18next } = useAppContext();
    const { extension } = useExtension(extensionKey);

    const hasMobileLicense = licenseIsMobile(
        extension.getIn(['license', 'licenseUsageType']),
    );

    return (
        <>
            <Divider />

            <SettingSection>
                {i18next.t('settings.profile.wizard.connectcalls')}
            </SettingSection>

            <RadioButton
                name="connectCalls"
                checked={selected === 'both'}
                onChange={() => onChange('both')}
            >
                {i18next.t(
                    'settings.profile.wizard.connectcalls.landlinemobile',
                )}
            </RadioButton>

            <RadioButton
                name="connectCalls"
                checked={selected === 'fixed'}
                onChange={() => onChange('fixed')}
            >
                {i18next.t('settings.profile.wizard.connectcalls.landline')}
            </RadioButton>

            {hasMobileLicense && (
                <RadioButton
                    name="connectCalls"
                    checked={selected === 'mobile'}
                    onChange={() => onChange('mobile')}
                >
                    {i18next.t('settings.profile.wizard.connectcalls.mobile')}
                </RadioButton>
            )}
        </>
    );
};

export default ConnectCallsToSection;
